import ExternalStoreMapper from '@/utilities/store-external-mappers'

import { SHARED_NAMESPACE } from '@/store/shared'

const VueRouteStore = {
  install (app, options) {
    const { router, store } = options
    const mapper = new ExternalStoreMapper(store)

    const actions = mapper.mapActions(SHARED_NAMESPACE, [
      'updateRSState',
    ])

    router.beforeEach((to, from, next) => {
      actions.updateRSState(from)
      next()
    })
  },
}

export default VueRouteStore
